var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2is02tweca"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.185553 0 0 0 0 0.467787 0 0 0 0 0.666837 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224.000000, -304.000000) translate(224.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 13,
    fill: "#FFF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#2is02tweca)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.156 7.5v2.083c-.06.977-.898 1.721-1.875 1.667H.47M.469 9.844L.469 12.188M9.375 5.625H.937c-.258 0-.468-.21-.468-.469V2.813C.469 1.258 1.728 0 3.28 0h10.313c.518 0 .937.42.937.938v.796c0 .371-.218.707-.557.857L10.312 4.22v.468c0 .518-.42.938-.937.938z",
    transform: "translate(15.000000, 16.000000) translate(2.500000, 2.500000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.656 3.178v3.385c0 .517-.42.937-.937.937H3.28c-1.035 0-1.875-.84-1.875-1.875h0M14.531 4.219L14.531 6.094",
    transform: "translate(15.000000, 16.000000) translate(2.500000, 2.500000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e9312f14.svg";
export { ForwardRef as ReactComponent };